// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CircleArrowDisabled: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 36 36"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="36"
            height="36"
            fill="currentColor"
        >
            <g fill="none" fillRule="evenodd">
                <circle cx="18" cy="18" r="18" fill="#E2001A" opacity=".33" />
                <path
                    fill="#FFF"
                    fillRule="nonzero"
                    d="M25.93,18.3508943 C26.0193969,18.1188451 26.0193969,17.8617812 25.93,17.6297319 C25.9126835,17.5895013 25.8890515,17.5523052 25.86,17.5195543 C25.8414783,17.462431 25.814512,17.4084113 25.78,17.359296 L21.78,12.3512236 C21.4292587,11.9398069 20.8157254,11.8817092 20.3942202,12.219999 C19.9727151,12.5582887 19.8955817,13.1706988 20.22,13.6032417 L22.92,16.9886987 L11,16.9886987 C10.4477153,16.9886987 10,17.4371367 10,17.9903131 C10,18.5434895 10.4477153,18.9919276 11,18.9919276 L22.92,18.9919276 L20.22,22.3673684 C20.0533523,22.5755486 19.9765266,22.841726 20.006564,23.1068581 C20.0366014,23.3719902 20.1710187,23.614158 20.38,23.7796448 C20.5559393,23.9210333 20.7744358,23.9986895 21,24 C21.304272,23.998595 21.5913526,23.8585094 21.78,23.6193865 L25.78,18.6113141 C25.816164,18.5669184 25.8433378,18.5158854 25.86,18.4610719 C25.8890515,18.4283211 25.9126835,18.391125 25.93,18.3508943 L25.93,18.3508943 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(CircleArrowDisabled);
